<script lang="ts">
    import type {DocumentDetailReactivePageData, DocumentDetailStaticPageData} from '../types';
    import {getPageContext} from 'shared/layouts/page-context';
    import KpCustomParagraph from 'shared/value-editors/internal/editors/search-or-edit/templates/KpCustomParagraph.svelte';

    const pageContext = getPageContext<DocumentDetailStaticPageData, DocumentDetailReactivePageData>();
    const model = pageContext.staticData.model;
</script>

<KpCustomParagraph content="{model.nextToHeaderParagraph}"
                   customClass="side-column-panel panel panel-default"
                   customWhitespaceHtmlFiltering/>